import { Langs } from "./domain/enums/common/LangsEnum";
import { environment } from "./environments/environment";

export const clientURL = environment.CLIENT_URL;
export const apiURL = environment.API_URL;
export const FILES_URL = `${apiURL}/files`;
export const NEWS_CLIENT_URL = `${clientURL}/news`;
export const EVENTS_CLIENT_URL = `${clientURL}/events`;
export const DEFAULT_LANGUAGE =
    (environment.BASE_LANGUAGE?.toLowerCase() as Langs) || Langs.UA;
export const AVAILABLE_LANGUAGES: Langs[] = environment.AVAILABLE_LANGUAGES
    ? environment.AVAILABLE_LANGUAGES.split(",").map(
        (l) => l.trim().toLowerCase() as unknown as Langs
    )
    : [Langs.UA, Langs.EN];
console.log("API URL:", apiURL);
